import { NgModule } from '@angular/core';
import { AppLanguageSource } from '@app/app-l10n';
import { I18nModule, provideTranslateScope } from '@fmnts/i18n';
import Translations from '../../../../translations';

/**
 * Module that provides the localization for the application.
 */
@NgModule({
  providers: [
    provideTranslateScope({
      translations: Translations,
      order: [
        AppLanguageSource.User,
        AppLanguageSource.Browser,
        AppLanguageSource.Default,
      ],
    }),
  ],
  exports: [I18nModule],
})
export class VerifyLocalizationModule {}
